module.exports = __webpack_public_path__ + "static/img/rule.6ea40d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/rule.png
// module id = fcBH
// module chunks = 1 3